import React from 'react';
import PropTypes from 'prop-types';

import Player from './Player';
import PositionFilter from './PositionFilter';
import '../css/player-grids.css';
import '../css/display-type.css';


const FreeAgents = props => (
  <div className="free-agents">
    <div id="free-agents-high" className="bucket">
      <div className="bucket__header">
        <h5>High-end</h5>
        <p>These free agents are the best at their position, but they’ll cost you.</p>
        <PositionFilter 
          filterPositions={props.filterPositions}
          filterKey='positionFilterHigh'
        />
      </div>
      <div className="player-grid">
        {Object.keys(props.freeAgentGroup).map((key) => {
          if (props.freeAgentGroup[key].type === "free agent" 
              && props.freeAgentGroup[key].bucket === 'high' 
              && (
                props.freeAgentGroup[key].position === props.positionFilterHigh 
                || props.positionFilterHigh === ''
                )
              ) {
            return <Player 
          key={key}
          index={key}
          alterTeam={props.alterTeam}
          details={props.freeAgentGroup[key]}
          drafted={props.drafted}
          />
          } return null;
        }
        )}
      </div>
    </div>

    <div id="free-agents-medium" className="bucket">
      <div className="bucket__header">
        <h5>Midrange</h5>
        <p>Not quite star-level, but not going to break the bank either.</p>
        <PositionFilter 
          filterPositions={props.filterPositions}
          filterKey='positionFilterMedium'
        />
      </div>
      <div className="player-grid">
        {Object.keys(props.freeAgentGroup).map((key) => {
          if (props.freeAgentGroup[key].type === "free agent" 
              && props.freeAgentGroup[key].bucket === 'medium' 
              && (
                props.freeAgentGroup[key].position === props.positionFilterMedium 
                || props.positionFilterMedium === ''
              )
            ) {
            return <Player 
          key={key}
          index={key}
          alterTeam={props.alterTeam}
          details={props.freeAgentGroup[key]}
          drafted={props.drafted}
          />
          } return null;
        }
        )}
      </div>
    </div>

    <div id="free-agents-low" className="bucket">
      <div className="bucket__header">
        <h5>Bargain bin</h5>
        <p>Time to plug some holes and fill out that roster.</p>
        <PositionFilter 
          filterPositions={props.filterPositions}
          filterKey='positionFilterLow'
        />
      </div>
      <div className="player-grid">
        {Object.keys(props.freeAgentGroup).map((key) => {
          if (props.freeAgentGroup[key].type === "free agent" 
              && props.freeAgentGroup[key].bucket === 'low' 
              && (
                props.freeAgentGroup[key].position === props.positionFilterLow 
                || props.positionFilterLow === ''
              )
            ) {
            return <Player 
          key={key}
          index={key}
          alterTeam={props.alterTeam}
          details={props.freeAgentGroup[key]}
          drafted={props.drafted}
          />
          } return null;
        }
        )}
      </div>
    </div>
  </div>
)

FreeAgents.propTypes = {
  freeAgentGroup: PropTypes.object,
  alterTeam: PropTypes.func,
  drafted: PropTypes.string,
  filterPositons: PropTypes.func,
  positionFilterHigh: PropTypes.string,
  positionFilterMedium: PropTypes.string,
  positionFilterLow: PropTypes.string,
}

export default FreeAgents;